<template>
  <div class="wrap">
    <v-icon
      name="spinner"
      class="loader"
      :scale="size"
      spin
    />
    <p
      v-if="label"
      class="label"
    >
      {{ label }}
    </p>
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: {
    label: {
      default: "Loading...",
      type: String
    },
    size: {
      default: 1.4,
      type: Number
    }
  }
};
</script>

<style scoped>
.wrap {
  @apply text-center py-4;
}

.label {
  @apply font-sans font-light text-support text-sm mb-0;
}

.loader {
  @apply mx-auto block mb-4 text-brand;
}
</style>
